/*-----------------------------------------------------
  Product.js
-----------------------------------------------------*/
window.theme = window.theme || {}

theme.VariantSKUS = (function() {
  var selectors = {
    product: '.Product',
    container: '.variant-gallery__container',
    label: '.variant-gallery__label span',
    form: 'form.product-form',
  }

  var cache = {};

  function initFoursixty(selector, variants) {

    
    var productIds = $(variants).map(function() { 
      return $(this).attr('data-product-id') 
    }).get().join()
    var scriptEl = document.createElement('script');


    var target = $(selector);

    if(target.length) {
      scriptEl.src = '//foursixty.com/media/scripts/fs.slider.v2.js'
  
      if (productIds) {
        productIds += ("," + $("#product-add").attr("data-product-id"));
        scriptEl.setAttribute('data-product-ids', productIds);
      } else {
        scriptEl.setAttribute('data-for-url', 'true');
      }
  
      scriptEl.setAttribute('data-feed-id', 'SUNDAYSOMEWHERE')
      scriptEl.setAttribute('data-product-images', 'false')
      scriptEl.setAttribute('data-theme', 'slider_v2')
      scriptEl.setAttribute('data-cell-size', '25%')
      scriptEl.setAttribute('data-page-size', '8')
      scriptEl.setAttribute('data-force-ssl', 'true')
  
      if (window.store == 'AU'){
        scriptEl.setAttribute('data-domain-override','sundaysomewhere.com.au')
      }
      
      target.append(scriptEl);
      checkFourSixty(target);
    }
  }

  function checkFourSixty(target) {
    setTimeout(function(){ 
      if($('#foursixty-container .fs-slider_v2').css('display') !== 'none') {
        $('#foursixty-container').addClass('is--active');
      }
    }, 1000);

  }

  function initMySunday() {
    var $sliderTarget = $('#foursixty-container--au .my-sunday');
    var $sliderImage = $('#foursixty-container--au .my-sunday .my-sunday__image');
    var $sliderContainer = document.querySelector('#foursixty-container--au .my-sunday');

    if(!$sliderImage.length) { return false; }
    mySundayWatch($sliderContainer);
    $sliderTarget.slick({
      dots: false,
      arrows: true,
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      draggable: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        }
      ]
    })
  }

  function mySundayWatch(target) {
    if (target) {
      var observerConfig = {
        attributes: true,
        childList: true,
        subtree: true,
      };
      // Start observing the target node for configured mutations
      var observer = new MutationObserver(callback);
      observer.observe(target, observerConfig);
    } else {
      return false;
    }
  }

  // Callback function to execute when mutations are observed
  function callback(mutationsList, observer) {
    for (var mutation of mutationsList) {
      if (mutation.type === 'childList') {
        showMySunday();
        observer.disconnect();
      }
    }
  }
  
  function showMySunday() {
    $('#foursixty-container--au').addClass('is--active');
  }
  

  function cacheSelectors() {
    cache = {
      $product: $(selectors.product),
      $container: $(selectors.container),
      $form: $(selectors.form),
      $label: $(selectors.label),
      $labelText: $(selectors.label).text(),
    }
  }

  function init() {
    cacheSelectors();
    if (!productIsOnSale()) {
      fetchItemsBySKU(getProductSKU());
      console.log(getProductSKU())
    }
    
    initMySunday();
    priceSwitchCheck();
  }

  function productIsOnSale() {
    return cache.$product.data('product-sale')
  }

  function createMarkup(product) {
    var productOptical = isOptical(), 
    variantType = product.type,
    variantOptical = isVariantOptical(variantType),
    sale = false;

    if (product.compare_at_price != null) {
      sale = true;
    }

    
    if (variantOptical === productOptical) {
      var featureImage = imageResize(product.featured_image, '_x500');
      return '<a href="/products/' + product.handle + '" class="variant-gallery__carousel-item" data-product-id="' +  product.id + '" data-product-title="' + product.title + '" data-product-sale="' + sale + '" data-product-optical="' + variantOptical + '"><img src="' + featureImage  + '" alt="' + product.title + '"></a>';
    } else {
      return '';
    }
  }

  function imageResize(image, size) {
    if (!image) {
      return;
    }
    if (image.includes('.jpeg') || image.includes('.jpg')) {
      var fileType = getFilterCountFileType(image);
      var productImage = image;
      var productImageSplit = productImage.split(fileType, 1);
      var productImageResize = productImageSplit + size + fileType;
      return productImageResize;
    } else {
      return image;
    }
  }

  function getFilterCountFileType(image) {
    if (image.includes('.jpeg')) {
      return '.jpeg';
    } else {
      return '.jpg';
    }
  }

  function isVariantOptical(productType) {
    if (productType.includes('Optical') || productType.includes('OPTICAL')) {
      return true;
    } else {
      return false;
    }
  }

  function isOptical() {
    return cache.$product.data('product-optical');
  }

  function fetchItemsBySKU(sku) {
    var markup    = '';
    for (var productVar in productVariants) {
      // skip loop if the property is from prototype
      if (!productVariants.hasOwnProperty(productVar)) continue;
      
      if(productVariants[productVar].variants[0].sku !== null ) {

        var currentSku = productVariants[productVar].variants[0].sku.toString().toLowerCase();
        if(currentSku.includes(sku)) {
          console.log(createMarkup(productVariants[productVar]));
          markup = markup + createMarkup(productVariants[productVar]);
        }     
      }
    }
    
    console.log(markup);
    initFoursixty('#foursixty-container', markup);
    renderTemplate(markup);
    variantCount();

  }

  function isSingleVariantProduct() {
    return ($('.variant-gallery__carousel-item').length <= 1)
  }

  function destroyCarousel() {
    return $('.variant-gallery__carousel').remove()
  }

  function setLabelHoverEvents() {
    $('.variant-gallery__carousel-item').on('mouseover', function() {
      cache.$label.removeClass('is-faded')
      cache.$label.html(getProductTitleFromTarget(this))
    })
    
    $('.variant-gallery__carousel-item').on('mouseout', function() {
      cache.$label.addClass('is-faded')
      cache.$label.html(cache.$labelText)
    })
  }

  function getProductSKU() {
    return cache.$container.closest('[data-product-sku]').data('product-sku');
  }

  function getProductTitleFromTarget(el) {
    return $(el).data('product-title').split(' in ')[1];
  }

  function getCurrentProductId() {
    return cache.$form.data('product-id');
  }

  function renderTemplate(template) {
    cache.$container.html('<div class="variant-gallery__carousel">' + template + '</div>')
  }

  function variantCount() {
    var variantLength = $('.variant-gallery__carousel-item').length;
    if (variantLength === 0 ) {
      $('.variant-gallery').addClass('variant-gallery--no-variants');
    }
  }

  function removeCurrentProductFromCarousel() {
    var currentId = getCurrentProductId()
    var variantItems = $('.variant-gallery__carousel-item')
    
    _.map(variantItems, function(item) {
      if ($(item).data('product-id') === currentId)
        $(item).remove()
    })
  }

  function groupOpticalProducts() {
    var variantItems = cache.$container.find('.variant-gallery__carousel-item')
    var isProductOptical = cache.$product.data('product-optical')

    _.map(variantItems, function(item) {
      var $item = $(item)
      if ($item.data('product-optical') != isProductOptical)
        $item.remove()
    })
  }

  function hideOnSaleProducts() {
    var variantItems = $('.variant-gallery__carousel-item');

    _.map(variantItems, function(item) {
      if ($(item).data('product-sale') === true)
        $(item).remove()
    })
  }

  function priceSwitchCheck(){
    if(cache.$product.data('gift-card')){
      selectorChange();
    }
  }
  function selectorChange(){
    $('.product-form__input').on('change', function() {
      $('.product-price').html($(this).val());
      window.location.search = jQuery.query.set("variant", 10);
      // Currency.currentCurrency
    })
  }

  function hideHoverLabel() {
    $(cache.$label).hide()
  }

  return {
    init: init
  }

})();


theme.VariantSKUS.init();